/**
 * 用于活动跟踪
 * 文档 https://confluence.sf-express.com/pages/viewpage.action?pageId=269565046
 * demo http://localhost:7080/#/?sysCode=SFBUY&from=https%3A%2F%2Fwww.sfbuy.com%2Flogin&lang=zh-CN&gjUtm=K2%3AnyLxsw,K3%3A%20nyLxsw,K4%3A,EVENT%3A37,ID%3A,UID%3A,UT%3A,UTCSTART%3A1682577680,UTCEND%3A1691217680,ET%3A0
 */
import Track from '@sf-intl/track-sdk'

export function init() {
  // cookie配置是否勾选
  Track.init({
    isCookie: false,
    isWarn: true, // 是否需要打开日志 可选 默认打开
  })

  // 切换cookie配置,修改对应的存储区域
  // Track.config({
  //   isCookie: false,
  // })
}

export function getUTM() {
  return Track.get()
}

